<button
  type="button"
  mat-icon-button
  class="icon primary"
  [matMenuTriggerFor]="languageMenu"
  [disabled]="isSaving"
  [attr.aria-busy]="isSaving"
  [attr.aria-label]="(isSaving ? 'LANG.SAVING' : 'COMMON.SELECT_LANGUAGE') | translate"
  [matTooltip]="(isSaving ? 'LANG.SAVING' : 'COMMON.SELECT_LANGUAGE') | translate">
  <mat-icon>{{ isSaving ? 'hourglass_empty' : 'language' }}</mat-icon>
</button>

<mat-menu #languageMenu="matMenu" xPosition="before">
  @let currentLanguage = currentLanguage$ | async;

  @for (language of (languages$ | async); track language.id) {
    <button type="button" mat-menu-item [disabled]="isSaving" (click)="onSelectLanguage(language.id, currentLanguage)">
      <mat-icon class="check-icon">
        {{ language.id === currentLanguage ? "check" : "" }}
      </mat-icon>

      <span>{{ language.name | translate }}</span>
    </button>
  }
</mat-menu>
